// Tema claro/oscuro: fuente única de la lógica de tema. Espeja el snippet
// anti-flash del index.html (data-theme="dark" en el root + localStorage
// 'qmsTheme'). Paridad con el mockup aprobado.

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'qmsTheme';

/** Tema persistido; 'light' por defecto o ante cualquier valor no reconocido. */
export function getStoredTheme(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

/** Aplica el tema al root (data-theme solo en oscuro) y lo persiste. */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'dark') {
    root.setAttribute('data-theme', 'dark');
  } else {
    root.removeAttribute('data-theme');
  }
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // almacenamiento no disponible (modo privado): el tema aplica igual en memoria.
  }
}

/** El tema opuesto, para el botón de alternar. */
export function nextTheme(current: Theme): Theme {
  return current === 'dark' ? 'light' : 'dark';
}
